import React, { Component, Fragment } from 'react'
import { withRouter } from 'react-router'
import DynamicForm from '../DynamicForm/DynamicForm'
import { Schema } from './InputSchema'
import { Flex, Box } from 'reflexbox'
import set from 'set-value'
import LegacyBranchesDialog from '../LegacyBranchesDialog/LegacyBranchesDialogContainer'
import HealtheraFooter from '../HealtheraFooter/HealtheraFooter'
import { HeaderContainer, HeaderTitle, BackButton, BounceAnimatedContainer, PaperContainer, HorizontalRule, SubHeader, HealtheraButton, CentredContainer } from '../../healtheraComponents'
import { validated } from '../../helpers'

class CreateBranch extends Component {

  state = {
    branchDetails: {
      active: true,
      name: '',
      address: {
        postcode: '',
        addressLine1: '',
        city: ''
      },
      primaryContact: {
        firstName: '',
        email: '',
        telephone: '',
        position: ''
      },
      organisationID: '',
      organisationName: ''
    },
    open: false,
    selectedBranch: {},
    validationArray: []
  }

  componentDidMount() {
    const { branchDetails } = this.state
    // Grab the orgID and save it with the branch details
    const { location: { state: { _id, pharmacy: { name: organisationName } = {} } = {} } = {} } = this.props
    this.setState({ open: true, branchDetails: { ...branchDetails, organisationID: _id, organisationName } })
    this.props.getAllOrphanBranches()
  }

  goBack() {
    const { location: { state: { _id } = {} } = {} } = this.props
    this.props.history.push(`${process.env.PUBLIC_URL}/organisations/${_id}`)
  }

  onChange({ field, value, validation }) {
    let { branchDetails, validationArray } = this.state
    set(validationArray, field, validation)
    set(branchDetails, field, value)
    this.setState({ branchDetails, validationArray })
  }

  handleChange(key, e) {
    const { branchDetails } = this.state
    this.setState({ branchDetails: { ...branchDetails, flags: { ...branchDetails.flags, [key]: e.target.checked } } })
  }

  handleSubmit() {
    const { branchDetails } = this.state
    this.props.addBranchToOrg(branchDetails)
    this.goBack()
  }


  handleClose = (value = {}) => {
    if (Object.entries(value).length !== 0) {
      const { branchDetails: { organisationID, organisationName } } = this.state
      this.props.addBranchToOrg({ _id: value.pharmacy_id, organisationName, organisationID })
    }
    this.goBack()
  }

  render() {
    const { branchDetails, validationArray, selectedBranch, selectedBranch: { pharmacy_id } = {} } = this.state
    const { orgID } = this.props
    const schema = Schema(selectedBranch)
    let validate = !validated(validationArray) || Object.keys(branchDetails.address).length < 3 || Object.keys(branchDetails.primaryContact).length < 5

    return (
      <Fragment>
        <BounceAnimatedContainer>
          <HeaderContainer padding={`20px 0 20px 0`} borderbottom={`none`} p={2} align='center'>
            <BackButton padding={`0 5px 0 0`} onClick={this.goBack.bind(this)} />
            <HeaderTitle cursor={`pointer`} onClick={this.goBack.bind(this)} px={2} w={1 / 3}>Branches</HeaderTitle>
            <LegacyBranchesDialog
              open={this.state.open}
              onClose={this.handleClose.bind(this)}
              selectedBranch={this.state.selectedBranch} />
          </HeaderContainer>
          {pharmacy_id && <PaperContainer elevation={0}>
            <HeaderContainer marginright={`0px`} padding={`0 0 20px 0`}>
              <HeaderTitle fontSize={`24px`}>Add New Branch</HeaderTitle>
            </HeaderContainer>
            <Flex>
              <Box pr={4} w={`50%`}>
                <SubHeader title='Branch Name & Address' />
                <DynamicForm disableForm={true} save={this.handleSubmit.bind(this)} margin={`normal`} onChange={this.onChange.bind(this)} fields={schema.name} />
                <DynamicForm save={this.handleSubmit.bind(this)} margin={`normal`} onChange={this.onChange.bind(this)} fields={schema.address} />
              </Box>
              <Box w={`50%`}>
                <SubHeader title='Contact Person' />
                <DynamicForm save={this.handleSubmit.bind(this)} margin={`normal`} defaultValue={schema.primaryContact} onChange={this.onChange.bind(this)} fields={schema.primaryContact} />
              </Box>
            </Flex>
            <HorizontalRule />
            <Flex>
            </Flex>
            <CentredContainer padding={`20px`}><HealtheraButton background={validate ? '#bbbbbb' : '#2f9d6d'} disabled={validate} onClick={this.handleSubmit.bind(this)}>Create Branch</HealtheraButton></CentredContainer>
          </PaperContainer>}
          {orgID && <HealtheraFooter />}
        </BounceAnimatedContainer>
      </Fragment>
    )
  }
}

export default withRouter(CreateBranch)
